export const API_HOST_URL =
  process.env.NODE_ENV === 'production' ? '' : `${process.env.VUE_APP_API_HOST_URL}`
export const BASE_URL = `${API_HOST_URL}/api/v1`
